import * as Yup from 'yup';
import dayjs from 'dayjs';

import { isBeforeDay } from '~libs/dayjs';

// Shared date-range rule: end date optional, but must not precede start (same-day OK).
// Mirrors the server-side validateDateRange guard in tp-assist-api.
export const endDateNotBeforeStart = Yup.string()
  .nullable()
  .test('after-start', 'Start date cannot be after end date', function endNotBeforeStart(endDate) {
    const { start_date: startDate } = this.parent;
    if (!endDate || !startDate) return true;
    return !isBeforeDay(endDate, dayjs(startDate));
  });
